import React, { useState, useEffect, useRef } from "react";
import { Col, Form, Button, Modal, Spinner } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import PaymentDone from "./Paymentdone";
import CheckoutPopup from "./CheckoutPopup";

import {
  fetchAddress,
  getCard,
  getEditQuotePay,
  getEditQuotePayment,
  payment,
  shippingCost,
  getRfqReasons,
  getRfqEstimatedResponseTime,
  getBusinessHours,
} from "../api/api";
import axiosInstance from "../axios/axiosInstance";
import { toast } from "react-toastify";
import Amount from "./Amount";
import ShippingRates from "./ShippingRates";
import CheckOutPay from "./checkOutPay";
import AddCard from "./Addcard";
import RFQReasonsModal from "./RFQReasonsModal";
import RFQReasonsInline from "./RFQReasonsInline";
import { Tooltip } from "react-tooltip";
import { fetchRfqReasonsAuto } from "../utils/rfqReasonsHelper";


const UserQuoteSidebar = ({
  amount,
  showDiv,
  buttonText,
  loadingBtnText,
  divideWeight,
  ShippingDBdataPay,
  quoteData,
  isPayble,
  loadId,
  bendAmount,
  orders = []
}) => {

  const [modalShow, setModalShow] = useState(false);
  const [quoteDataVal, setquoteData] = useState(false);
  const [rateVal, setrateVal] = useState("");
  const [loadingPayId, setLoadingPayID] = useState();
  const [modalShowCard, setModalShowCard] = useState(false);
  const [clickByUser, setclickByUser] = useState(false);

  const [showRfqModal, setShowRfqModal] = useState(false);
  const [rfqReasons, setRfqReasons] = useState(null);
  const [loadingReasons, setLoadingReasons] = useState(false);
  const [rfqError, setRfqError] = useState(null);
  const [rfqReasonsLoaded, setRfqReasonsLoaded] = useState(false); // Track if RFQ reasons have been successfully loaded
  const lastFetchedQuoteDataRef = useRef(null);
  const fetchTimeoutRef = useRef(null);

  // RFQ estimated response time and business hours state (fetched once and cached)
  const [estimatedResponseTime, setEstimatedResponseTime] = useState(null);
  const [businessHours, setBusinessHours] = useState(null);
  const [showBusinessHoursModal, setShowBusinessHoursModal] = useState(false);
  const estimateFetchedRef = useRef(false);

  const handleShowCard = () => {
    setModalShowCard(true);
    setclickByUser(true);
  };

  const handleCloseCard = () => setModalShowCard(false);

  const handleViewRfqReasons = async () => {
    // Get quote ID from localStorage
    const quoteDataStr = localStorage.getItem("setItemelementData");
    if (!quoteDataStr) {
      toast.error("Quote data not found");
      return;
    }

    let quoteId;
    try {
      const quoteObj = JSON.parse(quoteDataStr);
      quoteId = quoteObj._id;
    } catch (error) {
      toast.error("Error parsing quote data");
      return;
    }

    setLoadingReasons(true);
    setRfqError(null);

    try {
      const response = await getRfqReasons(quoteId);
      if (response.status === "success") {
        const items = response.data.items_with_rfq;
        // If API returns empty array, set to null to avoid showing fallback messages
        if (!items || items.length === 0) {
          setRfqReasons(null);
        } else {
          const processedReasons = processRfqReasons(items);
          setRfqReasons(processedReasons);
        }
        setRfqReasonsLoaded(true);
        setShowRfqModal(true);
      } else {
        setRfqError("Failed to load RFQ details");
        setRfqReasonsLoaded(true);
        toast.error("Failed to load RFQ details");
      }
    } catch (error) {
      console.error("Error fetching RFQ reasons:", error);
      setRfqError(error.message || "Error loading RFQ details");
      toast.error("Error loading RFQ details");
    } finally {
      setLoadingReasons(false);
    }
  };

  const checkIfPartExists = (itemId, stableIdentifier) => {
    // Method 1: Find by data-quote-id attribute (most reliable - uses MongoDB _id)
    if (itemId) {
      let element = document.querySelector(`[data-quote-id="${itemId}"]`);
      if (element) {
        return true;
      }
    }

    if (!stableIdentifier || stableIdentifier === 'N/A') {
      return false;
    }

    // Method 2: Find by data-stable-id attribute
    let element = document.querySelector(`[data-stable-id="${stableIdentifier}"]`);

    if (!element) {
      // Method 3: Find by data-subquote-number ending with stable identifier
      const allParts = document.querySelectorAll('[data-subquote-number]');

      for (let part of allParts) {
        const subquoteNumber = part.getAttribute('data-subquote-number');

        // Check if it ends with stable identifier
        if (subquoteNumber && subquoteNumber.endsWith(stableIdentifier)) {
          return true;
        }
      }

      // Method 4: Try finding by text content (fallback)
      const allPartDivs = document.querySelectorAll('.list-quotes-main');

      for (let partDiv of allPartDivs) {
        const partText = partDiv.textContent || '';
        // Look for the stable identifier in the text
        if (partText.includes(stableIdentifier)) {
          return true;
        }
      }
    }

    return !!element;
  };


  const processRfqReasons = (items) => {
    if (!items || !Array.isArray(items)) {
      return items;
    }

    return items.map(item => {
      const itemId = item.item_id;
      // part_code now contains the stable identifier (last 3 segments) from backend
      const stableIdentifier = item.part_code || 'N/A';

      // Can focus if item exists in DOM (prioritizes itemId, falls back to stableIdentifier)
      const canFocus = checkIfPartExists(itemId, stableIdentifier);

      return {
        ...item,
        canFocus: canFocus
      };
    });
  };

  const handlePartFocus = async (partData) => {
    // Close the modal
    setShowRfqModal(false);

    // Small delay to ensure modal close animation completes
    setTimeout(async () => {
      const itemId = partData.itemId; // MongoDB _id
      const stableIdentifier = partData.stableIdentifier; // e.g., "25-4414-001" (last 3 segments)

      if (!itemId && (!stableIdentifier || stableIdentifier === 'N/A')) {
        toast.error("Part identifier not available");
        return;
      }

      if (!orders) {
        toast.error("Order data not available - orders prop is missing");
        return;
      }

      if (!Array.isArray(orders)) {
        toast.error(`Order data not available - expected array, got ${typeof orders}`);
        return;
      }

      // Helper function to find element
      const findPartElement = () => {
        // Method 1: Find by data-quote-id attribute (most reliable - uses MongoDB _id)
        if (itemId) {
          let element = document.querySelector(`[data-quote-id="${itemId}"]`);
          if (element) {
            return element;
          }
        }

        if (!stableIdentifier || stableIdentifier === 'N/A') {
          return null;
        }

        // Method 2: Find by data-stable-id attribute
        let element = document.querySelector(`[data-stable-id="${stableIdentifier}"]`);
        if (element) {
          return element;
        }

        // Method 3: Find by data-subquote-number ending with stable identifier
        const allParts = document.querySelectorAll('[data-subquote-number]');
        for (let part of allParts) {
          const subquoteNumber = part.getAttribute('data-subquote-number');
          if (subquoteNumber && subquoteNumber.endsWith(stableIdentifier)) {
            return part;
          }
        }

        // Method 4: Try finding by text content (fallback)
        const allPartDivs = document.querySelectorAll('.list-quotes-main');
        for (let partDiv of allPartDivs) {
          const partText = partDiv.textContent || '';
          if (partText.includes(stableIdentifier)) {
            return partDiv;
          }
        }

        return null;
      };

      // Try finding element with retry (in case DOM hasn't updated yet)
      let element = findPartElement();
      let retries = 0;
      const maxRetries = 3;

      while (!element && retries < maxRetries) {
        await new Promise(resolve => setTimeout(resolve, 200)); // Wait 200ms
        element = findPartElement();
        retries++;
      }

      if (!element) {
        toast.error("Part not found in order display");
        return;
      }

      if (!element) {
        toast.error("Part element not found");
        return;
      }

      // Scroll to element
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });

      // Add highlight effect
      element.classList.add('part-focused');
      setTimeout(() => {
        element.classList.remove('part-focused');
      }, 2000); // Remove after 2 seconds
    }, 300); // Wait for modal close animation
  };

  useEffect(() => {
    setquoteData(quoteData);
  }, [quoteData]);

  // Override buttonText if RFQ reasons are loaded and empty - treat as no RFQ needed
  // This ensures that when API returns no RFQ reasons, we show normal checkout view with both options
  // If we have RFQ reasons (from bulk update or API), always show RFQ section (effectiveButtonText = 1)
  const effectiveButtonText = (rfqReasonsLoaded && (!rfqReasons || rfqReasons.length === 0))
    ? 0
    : (rfqReasons && rfqReasons.length > 0)
      ? 1
      : buttonText;

  // Inner fetch logic - runs synchronously. Used by both debounced (effect) and immediate (event) paths.
  const doRfqReasonsFetch = React.useCallback(() => {
    const quoteDataStr = localStorage.getItem("setItemelementData");
    if (!quoteDataStr) {
      // Try alternative location for payment flow
      const quoteDataPayStr = localStorage.getItem("setItemelementDataPay");
      if (quoteDataPayStr) {
        try {
          const quoteObj = JSON.parse(quoteDataPayStr);
          if (quoteObj._id) {
            // Check if we already fetched for this quote data to avoid duplicate calls
            const quoteDataKey = JSON.stringify({ id: quoteObj._id, check_status: quoteObj.check_status });
            if (lastFetchedQuoteDataRef.current !== quoteDataKey) {
              lastFetchedQuoteDataRef.current = quoteDataKey;
              fetchRfqReasonsAuto(
                quoteObj._id,
                (items) => {
                  setRfqReasons(items);
                  setRfqError(null);
                },
                (error) => {
                  console.error("Auto-fetch RFQ reasons failed:", error);
                  setRfqError(error);
                  // Don't show toast for auto-fetch failures to avoid annoying users
                }
              );
            }
          }
        } catch (error) {
          console.error("Error parsing quote data from payment flow:", error);
        }
      }
      return;
    }

    try {
      // Always read fresh from localStorage to ensure we get the latest check_status
      // This is important because localStorage might be updated before the prop changes
      const freshQuoteDataStr = localStorage.getItem("setItemelementData");
      const quoteObj = freshQuoteDataStr ? JSON.parse(freshQuoteDataStr) : JSON.parse(quoteDataStr);

      // NOTE: We intentionally do NOT check `if (quoteObj.check_status !== 1) { return; }` here.
      // When bending is disabled or quantity drops below threshold, check_status becomes 0,
      // but we still need to fetch to get updated (possibly empty) RFQ reasons.
      if (quoteObj._id) {
        // Build deduplication key based on main quote check_status AND sub-quote RFQ flags
        // This ensures we re-fetch when sub-quotes change even if main quote check_status stays the same
        const subQuotesStr = localStorage.getItem("setItempartsDBdata");
        let subQuoteRfqHash = "";
        if (subQuotesStr) {
          try {
            const subQuotes = JSON.parse(subQuotesStr);
            // Create a hash of RFQ-relevant fields from all sub-quotes
            // Include quantity, material_id, thickness_id, finishing_id since these changes can affect RFQ reasons
            const rfqFlags = subQuotes.map(q => ({
              id: q._id,
              bend_count: q.bend_count || 0,
              check_status: q.check_status || 0,
              price_check_status: q.price_check_status || 0,
              finish_check_status: q.finish_check_status || 0,
              quantity: q.quantity || 0, // Include quantity in hash
              material_id: q.material_id || null, // Include material_id in hash
              thickness_id: q.thickness_id || null, // Include thickness_id in hash
              finishing_id: q.finishing_id || null, // Include finishing_id in hash
              dimension_type: q.dimension_type !== undefined && q.dimension_type !== null ? q.dimension_type : 1, // Include dimension_type (mm/inches) in hash
              dimensions_width: q.dimensions?.width || null, // Include dimensions in hash
              dimensions_height: q.dimensions?.height || null, // Include dimensions in hash
            }));
            subQuoteRfqHash = JSON.stringify(rfqFlags);
          } catch (e) {
            // If parsing fails, use empty string
          }
        }

        const quoteDataKey = JSON.stringify({
          id: quoteObj._id,
          check_status: quoteObj.check_status,
          subQuoteRfqHash: subQuoteRfqHash
        });

        if (lastFetchedQuoteDataRef.current !== quoteDataKey) {
          lastFetchedQuoteDataRef.current = quoteDataKey;
          fetchRfqReasonsAuto(
            quoteObj._id,
            (items) => {
              // If API returns empty array, set to null to avoid showing fallback messages
              if (!items || items.length === 0) {
                setRfqReasons(null);
              } else {
                // Process RFQ reasons to check which items can be focused
                const processedReasons = processRfqReasons(items);
                setRfqReasons(processedReasons);
              }
              setRfqError(null);
              setRfqReasonsLoaded(true); // Mark as loaded successfully
            },
            (error) => {
              console.error("Auto-fetch RFQ reasons failed:", error);
              setRfqError(error);
              setRfqReasonsLoaded(true); // Mark as loaded (even if failed)
              // Don't show toast for auto-fetch failures to avoid annoying users
            }
          );
        }
      }
    } catch (error) {
      console.error("Error parsing quote data:", error);
    }
  }, [processRfqReasons]);

  // Debounced wrapper - used by effect. Event handler calls doRfqReasonsFetch directly to avoid
  // effect cleanup cancelling the pending timeout when state updates cause effect re-run.
  const performRfqReasonsFetch = React.useCallback(() => {
    if (fetchTimeoutRef.current) {
      clearTimeout(fetchTimeoutRef.current);
    }
    fetchTimeoutRef.current = setTimeout(doRfqReasonsFetch, 300);
  }, [doRfqReasonsFetch]);

  useEffect(() => {
    // Clear any pending fetch
    if (fetchTimeoutRef.current) {
      clearTimeout(fetchTimeoutRef.current);
    }

    // Use buttonText directly in condition
    const shouldFetch = buttonText === 1 && !isPayble;

    if (shouldFetch) {
      performRfqReasonsFetch();
    } else if (buttonText !== 1) {
      // Guard: only clear if we don't have rfqReasons.
      // After bulk update, rfqReasons are set via event before buttonText updates (React timing).
      // Without this guard, we'd clear valid rfqReasons. They'll clear naturally when fetch returns empty.
      if (!rfqReasons || rfqReasons.length === 0) {
        setRfqReasons(null);
        setRfqError(null);
        setRfqReasonsLoaded(false);
        lastFetchedQuoteDataRef.current = null;
      }
    }

    // Cleanup timeout on unmount or dependency change
    return () => {
      if (fetchTimeoutRef.current) {
        clearTimeout(fetchTimeoutRef.current);
      }
    };
  }, [buttonText, isPayble, quoteData, performRfqReasonsFetch]);

  // Listen to mainQuoteUpdated event to trigger RFQ reasons refresh after bulk updates
  useEffect(() => {
    const handleMainQuoteUpdated = (event) => {
      // If RFQ reasons are provided in the event, use them for immediate display (optimistic update)
      if (event?.detail?.rfqReasons) {
        const processedReasons = processRfqReasons(event.detail.rfqReasons);
        if (!processedReasons || processedReasons.length === 0) {
          setRfqReasons(null);
        } else {
          setRfqReasons(processedReasons);
        }
        setRfqError(null);
        setRfqReasonsLoaded(true);
      }
      // Always invalidate cache and fetch fresh RFQ reasons from API when quote is updated.
      // This ensures correct data after dimension switches, bulk updates, etc., even when
      // event payload is empty, stale, or deduplication would otherwise block the fetch.
      lastFetchedQuoteDataRef.current = null;
      // Call doRfqReasonsFetch immediately (no debounce) so the fetch runs before the effect
      // cleanup can cancel it. performRfqReasonsFetch uses debounce which gets cleared when
      // quoteData/buttonText change triggers effect re-run.
      doRfqReasonsFetch();
    };

    window.addEventListener('mainQuoteUpdated', handleMainQuoteUpdated);
    return () => {
      window.removeEventListener('mainQuoteUpdated', handleMainQuoteUpdated);
    };
  }, [doRfqReasonsFetch, processRfqReasons]);

  // Fetch RFQ estimated response time and business hours once when RFQ mode is active
  // This is independent of quote data changes - only fetch once and cache
  useEffect(() => {
    const shouldFetch = buttonText === 1 && !isPayble && !estimateFetchedRef.current;

    if (shouldFetch) {
      // Set ref immediately to prevent duplicate calls if effect runs multiple times
      // before the async operation completes (e.g., React Strict Mode, rapid prop changes)
      estimateFetchedRef.current = true;

      const fetchRfqInfo = async () => {
        try {
          // Fetch both endpoints in parallel
          const [responseTimeRes, businessHoursRes] = await Promise.all([
            getRfqEstimatedResponseTime(),
            getBusinessHours()
          ]);

          if (responseTimeRes.status === 'success' && responseTimeRes.data) {
            setEstimatedResponseTime(responseTimeRes.data);
          }

          if (businessHoursRes.status === 'success' && businessHoursRes.data) {
            setBusinessHours(businessHoursRes.data);
          }
        } catch (error) {
          console.error('Error fetching RFQ info:', error);
          // Keep ref as true even on error to prevent retry loops
        }
      };
      fetchRfqInfo();
    }
    // Don't reset when conditions change - keep cached value for session
  }, [buttonText, isPayble]);

  // Helper function to generate response time message
  // Format raw hours value to human-readable string
  // Under 1 hour: show minutes. 1+ hours: show hours with proper pluralization.
  const formatHoursToDisplay = (hours) => {
    if (hours < 1) {
      const minutes = Math.round(hours * 60);
      return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
    }
    const rounded = Math.round(hours);
    return `${rounded} ${rounded === 1 ? 'hour' : 'hours'}`;
  };

  const getResponseTimeMessage = (estimate) => {
    if (!estimate || !estimate.enabled || !estimate.formatted_time || estimate.formatted_time === 'unavailable') {
      return "We take RFQ's very seriously and will get back to you ASAP!";
    }

    // Outside business hours - show typical response time (closed status shown separately)
    if (estimate.is_business_hours === false && estimate.average_response_time) {
      return `During business hours, we typically respond within ${formatHoursToDisplay(estimate.average_response_time)}.`;
    }

    return `We typically respond to RFQs within ${estimate.formatted_time}.`;
  };

  // Helper function to format time from 24h to 12h format
  const formatTime12h = (time) => {
    const [hourStr, minute] = time.split(':');
    const hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minute} ${ampm}`;
  };

  // Helper function to format business hours for tooltip
  const formatBusinessHoursTooltip = (hours) => {
    if (!hours || !Array.isArray(hours) || hours.length === 0) {
      return null;
    }

    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    // Get open days
    const openDays = hours
      .filter(day => day.is_open)
      .sort((a, b) => a.day_of_week - b.day_of_week);

    if (openDays.length === 0) {
      return 'Currently closed';
    }

    // Check if all open days have same hours
    const firstDay = openDays[0];
    const allSameHours = openDays.every(
      day => day.start_time === firstDay.start_time && day.end_time === firstDay.end_time
    );

    if (allSameHours) {
      const dayRange = openDays.map(d => dayNames[d.day_of_week]).join(', ');
      return `Business Hours: ${dayRange} ${formatTime12h(firstDay.start_time)} - ${formatTime12h(firstDay.end_time)} EST`;
    }

    // Different hours per day
    return openDays
      .map(day => `${dayNames[day.day_of_week]}: ${formatTime12h(day.start_time)} - ${formatTime12h(day.end_time)}`)
      .join('\n');
  };

  // Get formatted business hours data for modal display
  const getBusinessHoursData = (hours) => {
    if (!hours || !Array.isArray(hours) || hours.length === 0) {
      return null;
    }

    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // Sort by day of week
    const sortedHours = [...hours].sort((a, b) => a.day_of_week - b.day_of_week);

    return sortedHours.map(day => ({
      day: dayNames[day.day_of_week],
      isOpen: day.is_open,
      hours: day.is_open ? `${formatTime12h(day.start_time)} - ${formatTime12h(day.end_time)}` : 'Closed'
    }));
  };
  const handleRateSelected = async (rate) => {
    setrateVal(rate);
    const elementId = localStorage.getItem("setItemelementDataPay");
    var getId = "";
    if (elementId) {
      getId = JSON.parse(elementId);
    }

    const data = {
      service_code: rate,
      id: getId._id,
    };
    try {
      const res = await shippingCost(data);

      setquoteData(res.data);
      localStorage.setItem("setItemelementDataPay", JSON.stringify(res.data));
    } catch (error) { }
  };

  const PaymentSubmit = async () => {
    if (rateVal == "" || rateVal == null) {
      toast.error("Please Select Shipping Option.");
      return;
    }
    setLoading(true);
    const elementId = localStorage.getItem("setItemelementDataPay");
    var getId = "";

    if (elementId) {
      getId = JSON.parse(elementId);
    }
    const data = {
      id: getId._id,
    };
    const res = await payment(data);
    try {
      if (res.status == "success") {
        setModalShow(true);
        setLoading(false);
        localStorage.removeItem("setItemelementDataPay");
        localStorage.removeItem("setItempartsDBdataPay");
        localStorage.removeItem("ShippingDBdataPay");
        localStorage.removeItem("divideWeight");
      } else {
        toast.error(res.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const [successMessage, setSuccessMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => {
    setShowModal(true);
  }
  const handleCloseModal = () => {
    setShowModal(false);
  }


  useEffect(() => {
    setShowModal(false);
    loadData();
    setSuccessMessage("");
  }, [successMessage])
  const handleClose = () => setModalShow(false);
  const handleClosePay = () => setModalShowPay(false);
  const [key, setKey] = useState("card");
  const navigate = useNavigate();
  const [showDiv1, setShowDiv1] = useState(true);
  const [showDiv2, setShowDiv2] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const toggleDiv = (divNumber) => {
    if (divNumber === 1) {
      setShowDiv1(false);
      setShowDiv2(true);
    } else if (divNumber === 2) {
      setShowDiv1(true);
      setShowDiv2(false);
    }
  };
  const [name, setName] = useState("Andrew James");
  const [address, setAddresss] = useState([]);
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("andrewjames@gmail.com");
  const [address1, setAddress1] = useState("indiit solutions");
  const [city, setCity] = useState("New York");
  const [zipcode, setZipcode] = useState("10001");
  const [phoneno, setPhoneno] = useState("1 9876231221");
  const [loading, setLoading] = useState(true);
  const [loadingPay, setLoadingPay] = useState(false);
  const [modalShowPay, setModalShowPay] = useState(false);
  const [PayLoad, setPayLoad] = useState(false);
  const [PayLoadRfq, setPayLoadRfq] = useState(false);
  const [shippingInfo, setshippingInfo] = useState(false);
  const [ParamType, setParamType] = useState("");
  const RequestQuote = async (id) => {
    const data = {
      id: id,
    };
    setLoadingPay(id);
    setLoadingPayID(id);
    setPayLoad(true);
    try {
      const response = await getEditQuotePay(data);
      setshippingInfo(response.data);
      setLoadingPay(false);
      setModalShowPay(true);
      setPayLoad(false);
    } catch (error) {
      setPayLoad(false);
      setLoadingPay(false);
      toast.error("Something wents wrong.");
    }
  };
  const handleUpdateQuoteChange = async (type_param) => {
    const elementId = localStorage.getItem("setItemelementData");
    const updatedQuoteData = JSON.parse(
      localStorage.getItem("setItempartsDBdata")
    );
    let isValid = true; // Assume everything is valid initially

    for (const quote of updatedQuoteData) {
      if (!quote.material_id) {
        isValid = false;
        toast.error(`Please select Material.`);
        break; // Stop the loop if validation fails
      }
      if (!quote.thickness_id) {
        isValid = false;
        toast.error(`Please select Thickness.`);
        break; // Stop the loop if validation fails
      }
      if (!quote.finishing_id) {
        isValid = false;
        toast.error(`Please select Finish.`);
        break; // Stop the loop if validation fails
      }
      if (quote.bend_count == 1) {
        if (quote.step_file_bend == null || quote.step_file_bend == "") {
          isValid = false;
          toast.error(`Please upload bend STEP file.`);
          break; // Stop the loop if validation fails
        }
      }
    }

    // Only proceed with submission if all required fields are selected
    if (isValid) {
      let getId = "";

      if (elementId) {
        getId = JSON.parse(elementId);
      }
      if (getId && getId._id) {
        var id = getId._id;
      }
      const data = {
        id: id,
        type: type_param
      };
      try {
        if (type_param == "rfq") {
          setPayLoadRfq(true)
        } else {
          setPayLoad(true);
        }

        const response = await getEditQuotePayment(data);
        setshippingInfo(response.data);

        // if (response.data?.requestQuoteDB?.check_status) {
        const updatedShippingInfo = {
          ...response.data,
          requestQuoteDB: {
            ...response.data.requestQuoteDB,
            check_status: type_param == 'rfq' ? 1 : response.data?.requestQuoteDB?.check_status, // or whatever value you want to set
          }
        };
        setshippingInfo(updatedShippingInfo);
        // }


        setLoadingPayID(getId);
        setModalShowPay(true);
        if (type_param == "rfq") {
          setPayLoadRfq(false)
        } else {
          setPayLoad(false);
        }
        // setModalShowPay(false);
      } catch (error) {
        if (type_param == "rfq") {
          setPayLoadRfq(false)
        } else {
          setPayLoad(false);
        }
        // setModalShowPay(false);
        toast.error("Something wents wrong.");
      }
    }
  };

  const [savedCards, onSelectCard] = useState([]);
  const [cardsData, setCards] = useState([]);
  const loadData = async () => {
    setLoading(true);
    try {
      const [response] = await Promise.all([fetchAddress()]);
      setAddresss(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadCards = async () => {
    try {
      setLoading(true);
      const response = await getCard(); // Call your API function
      setCards(response.data); // Assuming the data is in response.data
    } catch (error) {
      console.error("Error fetching cards:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (savedCards && !Array.isArray(savedCards)) {
      setCards((prevCards) => [...prevCards, savedCards]);
    } else if (Array.isArray(savedCards)) {
      setCards((prevCards) => [...prevCards, ...savedCards]);
    }
  }, [savedCards]);

  useEffect(() => {
    loadData();
    loadCards();
    setShowDiv2(showDiv);
    setShowDiv1(!showDiv);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    setToken(token);
  }, []);
  useEffect(() => {
    if (modalShow) {
      const timer = setTimeout(() => {
        navigate("/orders");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [modalShow]);
  return (
    <>
      {showDiv1 && (
        <div className="quotes-sidebar">
          <div className="quotes-inner">
            <div className="head-quotes">
              <h2 className="mb-0">Quote Summary</h2>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <span className="quotesitem">Parts Subtotal</span>
              <span className="quotesitem quotesright">
                <Amount amount={parseFloat(amount || 0)} />
              </span>
            </div>

            {/* Bending - only show if it exists */}
            {bendAmount !== undefined && bendAmount > 0 && (
              <div className="d-flex align-items-center justify-content-between">
                <span className="quotesitem">Services</span>
                <span className="quotesitem quotesright">
                  <Amount amount={bendAmount} />{" "}
                </span>
              </div>
            )}

            {/* Total */}
            <div className="d-flex align-items-center justify-content-between mt-2">
              <span className="quotessubtotal">Total</span>
              <span className="quotesprice">
                <Amount
                  amount={
                    parseFloat(amount || 0) +
                    parseFloat(bendAmount || 0)
                  }
                />
              </span>
            </div>

            {token != "" && token != undefined && token != null ? (
              <>
                {loadingBtnText ? (
                  <div className="text-center mt-3 mb-3">
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <p className="mt-2 mb-0">Loading options...</p>
                  </div>
                ) : (
                  <>
                    <div className="text-color-shipping">
                      {quoteData.status == 3 ?
                        <>
                          <hr />
                          <p>RFQ Rejected.</p>
                        </>
                        :
                        effectiveButtonText == 1 ? (
                          <>
                            <hr />
                            {isPayble ? (
                              effectiveButtonText == 1 ? (
                                <p>Waiting for admin approval.</p>
                              ) : (
                                <p>
                                  An item in your quote requires approval. Please
                                  submit your RFQ and we'll get back to you ASAP!
                                </p>
                              )
                            ) : (
                              <>
                                <p className="text-start mb-2">
                                  A Request For Quote is needed for the following reasons:
                                </p>
                                {rfqReasons && rfqReasons.length > 0 ? (
                                  <>
                                    {rfqReasons.length <= 5 ? (
                                      // Show inline display for ≤5 items
                                      <>
                                        <RFQReasonsInline items={rfqReasons} onPartClick={handlePartFocus} />
                                        {/* Show closed status when outside business hours */}
                                        {estimatedResponseTime?.is_business_hours === false && (
                                          <div className="alert alert-warning py-1 px-2 mb-0 mt-2">
                                            <div className="d-flex align-items-center gap-2">
                                              <Icon icon="mdi:clock-alert-outline" width={14} height={14} style={{ flexShrink: 0 }} />
                                              <span className="small fw-semibold" style={{ marginBottom: 0 }}>We're currently closed</span>
                                            </div>
                                          </div>
                                        )}
                                        <p
                                          className="text-start mt-2 mb-0 small"
                                          data-tooltip-id="business-hours-tooltip"
                                          data-tooltip-content={formatBusinessHoursTooltip(businessHours)}
                                          style={{ cursor: businessHours ? 'help' : 'default' }}
                                        >
                                          {getResponseTimeMessage(estimatedResponseTime)}
                                          {businessHours && (
                                            <>
                                              {' '}
                                              <span
                                                className="text-primary"
                                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                onClick={() => setShowBusinessHoursModal(true)}
                                              >
                                                View hours
                                              </span>
                                            </>
                                          )}
                                        </p>
                                      </>
                                    ) : (
                                      // Show first 5 items + "View More" button for >5 items
                                      <>
                                        <RFQReasonsInline items={rfqReasons.slice(0, 5)} onPartClick={handlePartFocus} />
                                        {/* Show closed status when outside business hours */}
                                        {estimatedResponseTime?.is_business_hours === false && (
                                          <div className="alert alert-warning py-1 px-2 mb-0 mt-2">
                                            <div className="d-flex align-items-center gap-2">
                                              <Icon icon="mdi:clock-alert-outline" width={14} height={14} style={{ flexShrink: 0 }} />
                                              <span className="small fw-semibold" style={{ marginBottom: 0 }}>We're currently closed</span>
                                            </div>
                                          </div>
                                        )}
                                        <p
                                          className="text-start mt-2 mb-2 small"
                                          data-tooltip-id="business-hours-tooltip"
                                          data-tooltip-content={formatBusinessHoursTooltip(businessHours)}
                                          style={{ cursor: businessHours ? 'help' : 'default' }}
                                        >
                                          {getResponseTimeMessage(estimatedResponseTime)}
                                          {businessHours && (
                                            <>
                                              {' '}
                                              <span
                                                className="text-primary"
                                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                onClick={() => setShowBusinessHoursModal(true)}
                                              >
                                                View hours
                                              </span>
                                            </>
                                          )}
                                        </p>
                                        <Button
                                          className="w-100 mt-2"
                                          onClick={handleViewRfqReasons}
                                          disabled={loadingReasons}
                                        >
                                          {loadingReasons ? (
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          ) : (
                                            `View More (${rfqReasons.length - 5} more)`
                                          )}
                                        </Button>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  // Fallback to generic message only if RFQ reasons haven't loaded yet
                                  <>
                                    <ul className="ps-3">
                                      <li>Part is over our 36 inch limit and needs review</li>
                                      <li>A service has been selected and needs review</li>
                                      <li>Material is non-stock and needs review</li>
                                    </ul>
                                    <p
                                      className="text-start mb-0 small d-flex align-items-center gap-1"
                                      data-tooltip-id="business-hours-tooltip"
                                      data-tooltip-content={formatBusinessHoursTooltip(businessHours)}
                                      style={{ cursor: businessHours ? 'help' : 'default' }}
                                    >
                                      {getResponseTimeMessage(estimatedResponseTime)}
                                      {businessHours && (
                                        <Icon
                                          icon="material-symbols:info-outline-rounded"
                                          width={16}
                                          height={16}
                                          style={{ cursor: 'pointer', flexShrink: 0 }}
                                          onClick={() => setShowBusinessHoursModal(true)}
                                        />
                                      )}
                                    </p>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <hr />
                            {/* {!isPayble && <span>Price is for cutting only.</span>} */}
                            <p>Shipping & Taxes will be calculated at checkout</p>
                          </>
                        )}
                    </div>
                    {quoteData.status == 3 ?
                      <></> :
                      isPayble ? (
                        <>
                          {effectiveButtonText == 1 ? (
                            <></>
                          ) : (
                            <Button
                              className="w-100 mt-3"
                              onClick={() => RequestQuote(loadId)}
                              disabled={PayLoad}
                            >
                              {PayLoad ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : effectiveButtonText == 1 ? (
                                "Request a Quote"
                              ) : (
                                "Proceed to checkout"
                              )}
                            </Button>
                          )}
                        </>
                      ) : (
                        <>
                          {effectiveButtonText == 1 ? (
                            <div className="btn_rfq_tooltip position-relative">
                              <Button
                                className="w-100 mt-3"
                                onClick={() => {
                                  handleUpdateQuoteChange("rfq");
                                  setParamType("rfq");
                                }}
                                disabled={PayLoadRfq}
                              >
                                {PayLoadRfq ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) :
                                  "Request a Quote"
                                }
                              </Button>
                              <Link data-tooltip-id="add-request-tooltip" className="position-absolute iconinfotext">
                                <Icon icon={"material-symbols:info-outline-rounded"} width={17} height={17} />
                              </Link>
                              <Tooltip
                                id="add-request-tooltip"
                                place="right"
                                content={
                                  <>
                                    Request a Quote if you would<br />
                                    like Laser Bros to review your<br />
                                    order before purchasing.
                                  </>
                                }
                              />
                            </div>
                          ) : (
                            <>
                              <Button
                                className="w-100 mt-3"
                                onClick={() => {
                                  handleUpdateQuoteChange("");
                                  setParamType("");
                                }}
                                disabled={PayLoad}
                              >
                                {PayLoad ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  "Proceed to checkout"
                                )}
                              </Button>
                              <p className="textForOr text-center mb-0 mt-3">OR</p>
                              <div className="btn_rfq_tooltip position-relative">
                                <Button
                                  className="w-100 mt-3"
                                  onClick={() => {
                                    handleUpdateQuoteChange("rfq");
                                    setParamType("rfq");
                                  }}
                                  disabled={PayLoadRfq}
                                >
                                  {PayLoadRfq ? (
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  ) :
                                    "Request a Quote"
                                  }
                                </Button>
                                <Link data-tooltip-id="add-request-tooltip-2" className="position-absolute iconinfotext">
                                  <Icon icon={"material-symbols:info-outline-rounded"} width={17} height={17} />
                                </Link>
                                <Tooltip
                                  id="add-request-tooltip-2"
                                  place="right"
                                  content={
                                    <>
                                      Request a Quote if you would<br />
                                      like Laser Bros to review your<br />
                                      order before purchasing.
                                    </>
                                  }
                                />
                              </div>
                            </>
                          )}
                        </>

                      )}
                  </>
                )}
              </>
            ) : (
              <>
              </>
            )}
          </div>
        </div>
      )}
      {showDiv2 && (
        <>
          <div className="quotes-sidebar">
            <div className="quotes-inner">
              <div className="head-quotes d-flex align-items-center justify-content-between">
                <h2 className="mb-0">Checkout</h2>
                {/* <Link className="btnicon" onClick={() => toggleDiv(2)}>
                  <Icon icon="ion:chevron-back" />
                </Link> */}
              </div>
              <Form className="accountform">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="quotesitem">Subtotal</span>
                  <span className="quotesitem quotesright">
                    <Amount amount={parseFloat(amount || 0)} />{" "}
                  </span>
                </div>

                {/* Bending - only show if it exists */}
                {bendAmount !== undefined && bendAmount > 0 && (
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="quotesitem">Services</span>
                    <span className="quotesitem quotesright">
                      <Amount amount={bendAmount} />{" "}
                    </span>
                  </div>
                )}

                {/* Shipping - only show if it exists */}
                {quoteDataVal.shipping_price !== undefined && quoteDataVal.shipping_price > 0 && (
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="quotesitem">Shipping</span>
                    <span className="quotesitem quotesright">
                      <Amount amount={quoteDataVal.shipping_price} />{" "}
                    </span>
                  </div>
                )}

                {/* Tax - only show if it exists */}
                {quoteDataVal.transactionFees !== undefined && quoteDataVal.transactionFees > 0 && (
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="quotesitem">Sales Tax</span>
                    <span className="quotesitem quotesright">
                      <Amount amount={quoteDataVal.transactionFees} />{" "}
                    </span>
                  </div>
                )}

                <div className="d-flex align-items-center justify-content-between mt-2">
                  <span className="quotessubtotal">Total</span>
                  <span className="quotesprice">
                    <Amount
                      amount={
                        parseFloat(amount || 0) +
                        parseFloat(bendAmount || 0) +
                        parseFloat(
                          rateVal == "" ? 0 : quoteDataVal.shipping_price || 0
                        ) +
                        parseFloat(quoteDataVal.transactionFees || 0)
                      }
                    />
                  </span>
                </div>
                <ShippingRates
                  shippingRates={ShippingDBdataPay}
                  divideWeight={divideWeight}
                  onRateSelected={handleRateSelected}
                  RequestQuote={buttonText}
                // service_code={quoteDataVal.service_code}
                />
                <hr className="quotes-separator" />
                <small className=" mb-3 d-block">
                  <i>
                    Address : If you want to change address{" "}
                    <Link className="btn-address" to={`/my-addresses`}>
                      {" "}
                      click here
                    </Link>
                  </i>
                </small>
                {address.length === 0 ? (
                  <Col>
                    <p>No addresses found</p>
                  </Col>
                ) : (
                  address.map((addr) =>
                    addr.is_default === 1 ? (
                      <Col xl={12} lg={12} md={12} className="mb-4">
                        <div className="addresses-grid">
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <h2 className="mb-0">{addr.full_name}</h2>
                          </div>
                          <p className="mb-2">{addr.phone_number}</p>
                          <p className="mb-3">
                            {addr.address_line_1}, {addr.city}, {addr.pincode},{" "}
                            {addr.country}
                          </p>
                          <div className="btn-bottom">
                            <Link
                              className="btn-address"
                              to={`/my-address/edit-address/${addr._id}`}
                            >
                              <Icon icon="mynaui:edit" />
                            </Link>
                          </div>
                        </div>
                      </Col>
                    ) : null
                  )
                )}
                <small className=" mb-3 d-block">
                  <i>
                    Card : If you want to change card{" "}
                    <Link className="btn-address" to={`/payment-cards`}>
                      {" "}
                      click here
                    </Link>
                  </i>
                </small>
                {cardsData.length === 0 ? (
                  <Col>
                    <p>No cards found</p>
                  </Col>
                ) : (
                  cardsData.map(
                    (card) =>
                      card.is_default === 1 && (
                        <Col
                          xl={12}
                          lg={12}
                          md={12}
                          className="mb-4"
                          key={card.card_id}
                        >
                          <div className="addresses-grids payment-grids">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              {/* <Image src={visa} className="img-fluid mb-3" alt="" /> */}
                            </div>
                            <p
                              className="mb-2 card-no"
                              style={{ fontSize: "13px" }}
                            >
                              **** **** **** {card.last4}
                            </p>

                            <div className="card-actions">
                              <div className="card-info">
                                <strong>Expiry Date</strong> {card.exp_month}/
                                {card.exp_year}
                              </div>
                              <div className="card-info">
                                <strong>Name</strong>{" "}
                                {card.full_name.toUpperCase()}
                              </div>
                            </div>
                          </div>
                        </Col>
                      )
                  )
                )}
                <Button
                  className="w-100 mt-3"
                  onClick={PaymentSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <>
                      Proceed To Pay{" "}
                      <b>
                        <Amount
                          amount={
                            parseFloat(amount || 0) +
                            parseFloat(bendAmount || 0) +
                            parseFloat(
                              rateVal == ""
                                ? 0
                                : quoteDataVal.shipping_price || 0
                            ) +
                            parseFloat(quoteDataVal.transactionFees || 0)
                          }
                        />
                      </b>
                    </>
                  )}
                </Button>
              </Form>
            </div>
          </div>
        </>
      )}
      <PaymentDone show={modalShow} handleClose={handleClose} />
      <AddCard
        show={modalShowCard}
        handleClose={handleCloseCard}
        onCardAdded={loadCards}
        title="Add Card"
        onSelectCard={onSelectCard}
        clickByUser={clickByUser}
        isSetDefault={true}
      />
      {isPayble ? (
        <CheckOutPay
          bendAmountPrice={bendAmount}
          show={modalShowPay}
          loadingPayId={loadingPayId}
          handleClose={handleClosePay}
          address={address}
          shippingInfo={shippingInfo}
          cardsData={cardsData}
          handleShowCard={handleShowCard}
        />
      ) : (
        <CheckoutPopup
          bendAmountPrice={bendAmount}
          loadingPayId={loadingPayId}
          setSuccessMessage={setSuccessMessage}
          show={modalShowPay}
          successMessage={successMessage}
          handleShow={handleShow}
          showPopup={showModal}
          handleCloseModal={handleCloseModal}
          handleClose={handleClosePay}
          modalShowCard={modalShowCard}
          handleShowCard={handleShowCard}
          handleCloseCard={handleCloseCard}
          address={address}
          shippingInfo={shippingInfo}
          cardsData={cardsData}
          ParamType={ParamType}
        />
      )}

      {/* Modal for RFQ reasons */}
      <Modal
        show={showRfqModal}
        onHide={() => setShowRfqModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>RFQ Required - Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {rfqError ? (
            <p className="text-danger">Error: {rfqError}</p>
          ) : rfqReasons ? (
            <RFQReasonsModal items={rfqReasons} onPartClick={handlePartFocus} />
          ) : (
            <p>Loading...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowRfqModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Tooltip for business hours */}
      <Tooltip id="business-hours-tooltip" place="top" />

      {/* Modal for business hours and response time details */}
      <Modal
        show={showBusinessHoursModal}
        onHide={() => setShowBusinessHoursModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>RFQ Response Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Open/Closed Status - shown above estimated response time */}
          {estimatedResponseTime && estimatedResponseTime.enabled && estimatedResponseTime.formatted_time && estimatedResponseTime.formatted_time !== 'unavailable' && (
            estimatedResponseTime.is_business_hours === false ? (
              <div className="alert alert-warning py-2 px-3 mb-3">
                <div className="d-flex align-items-center gap-2">
                  <Icon icon="mdi:clock-alert-outline" width={18} height={18} />
                  <span className="small fw-semibold">We're currently closed</span>
                </div>
              </div>
            ) : (
              <div className="alert alert-success py-2 px-3 mb-3">
                <div className="d-flex align-items-center gap-2">
                  <Icon icon="mdi:check-circle-outline" width={16} height={16} />
                  <span className="small">We're currently open and reviewing RFQs</span>
                </div>
              </div>
            )
          )}

          {/* Estimated Response Time Section */}
          {estimatedResponseTime && estimatedResponseTime.enabled && estimatedResponseTime.formatted_time && estimatedResponseTime.formatted_time !== 'unavailable' && (
            <div className="mb-4">
              <h6 className="fw-bold mb-3">Estimated Response Time</h6>

              {estimatedResponseTime.is_business_hours === false ? (
                <>
                  {/* Outside business hours - show breakdown */}
                  {estimatedResponseTime.time_until_business_hours && estimatedResponseTime.time_until_business_hours < 24 ? (
                    <>
                      {/* Less than a day - full breakdown with hours */}
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <Icon icon="mdi:clock-outline" width={20} height={20} />
                        <span className="fs-5 fw-semibold">{estimatedResponseTime.formatted_time}</span>
                        <span className="small text-muted" style={{ position: 'relative', top: '3px' }}>(total wait time)</span>
                      </div>

                      <p className="small mb-2">
                        This estimate includes:
                      </p>
                      <ul className="small mb-2 ps-3">
                        {estimatedResponseTime.time_until_business_hours && (
                          <li>
                            <strong>~{formatHoursToDisplay(estimatedResponseTime.time_until_business_hours)}</strong> until we reopen
                          </li>
                        )}
                        {estimatedResponseTime.average_response_time && (
                          <li>
                            <strong>~{formatHoursToDisplay(estimatedResponseTime.average_response_time)}</strong> typical review time during business hours
                          </li>
                        )}
                      </ul>
                    </>
                  ) : (
                    <>
                      {/* A day or more - full breakdown with days */}
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <Icon icon="mdi:clock-outline" width={20} height={20} />
                        <span className="fs-5 fw-semibold">{estimatedResponseTime.formatted_time}</span>
                        <span className="small text-muted" style={{ position: 'relative', top: '3px' }}>(total wait time)</span>
                      </div>

                      <p className="small mb-2">
                        This estimate includes:
                      </p>
                      <ul className="small mb-2 ps-3">
                        {estimatedResponseTime.time_until_business_hours && (() => {
                          const days = Math.round(estimatedResponseTime.time_until_business_hours / 24);
                          return (
                            <li>
                              <strong>~{days} {days === 1 ? 'day' : 'days'}</strong> until we reopen
                            </li>
                          );
                        })()}
                        {estimatedResponseTime.average_response_time && (
                          <li>
                            <strong>~{formatHoursToDisplay(estimatedResponseTime.average_response_time)}</strong> typical review time during business hours
                          </li>
                        )}
                      </ul>
                    </>
                  )}
                </>
              ) : (
                <>
                  {/* During business hours - simple display */}
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Icon icon="mdi:clock-outline" width={20} height={20} />
                    <span className="fs-5 fw-semibold">{estimatedResponseTime.formatted_time}</span>
                  </div>
                </>
              )}

              {estimatedResponseTime.sample_size && (
                <p className="small text-muted mb-0 mt-2">
                  Based on our last {estimatedResponseTime.sample_size} RFQ responses.
                </p>
              )}
            </div>
          )}

          {/* Business Hours Section */}
          {businessHours && getBusinessHoursData(businessHours) ? (
            <>
              <h6 className="fw-bold mb-3">Business Hours</h6>
              <p className="small mb-3">
                Our team reviews and responds to RFQ requests during the following hours:
              </p>
              <table className="table table-sm mb-0">
                <tbody>
                  {getBusinessHoursData(businessHours).map((day, index) => (
                    <tr key={index} className={!day.isOpen ? 'text-muted' : ''}>
                      <td style={{ width: '40%' }}><strong>{day.day}</strong></td>
                      <td>{day.hours}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <p className="small text-muted mt-3 mb-0">
                All times are in Eastern Time (EST/EDT).
              </p>
            </>
          ) : (
            <p>Business hours information is not available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowBusinessHoursModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserQuoteSidebar;
